module.exports = __webpack_public_path__ + "img/20220411_125739.5f4e397a.jpg";